import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconSocialLinkedIn extends MeasurIcon<
  SVGProps<SVGSVGElement>
> {
  render() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M13.3333 6.66666C14.6594 6.66666 15.9312 7.19345 16.8689 8.13113C17.8066 9.06881 18.3333 10.3406 18.3333 11.6667V17.5H15V11.6667C15 11.2246 14.8244 10.8007 14.5119 10.4882C14.1993 10.1756 13.7754 10 13.3333 10C12.8913 10 12.4674 10.1756 12.1548 10.4882C11.8423 10.8007 11.6667 11.2246 11.6667 11.6667V17.5H8.33334V11.6667C8.33334 10.3406 8.86013 9.06881 9.79781 8.13113C10.7355 7.19345 12.0073 6.66666 13.3333 6.66666Z"
          strokeWidth="1.66667"
        />
        <path
          d="M4.99999 7.5H1.66666V17.5H4.99999V7.5Z"
          strokeWidth="1.66667"
        />
        <path
          d="M3.33332 5C4.2538 5 4.99999 4.25381 4.99999 3.33333C4.99999 2.41286 4.2538 1.66666 3.33332 1.66666C2.41285 1.66666 1.66666 2.41286 1.66666 3.33333C1.66666 4.25381 2.41285 5 3.33332 5Z"
          strokeWidth="1.66667"
        />
      </svg>
    )
  }
}
